import React, { Component } from 'react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import { DragDropContext, type DropResult } from 'react-beautiful-dnd';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { ItemProviderDataSection } from '../../../../common/types/item-provider';
import { trimItemsBySection } from '../../../../common/utils';

import ItemList from './item';

type State = {
	isDragging: boolean;
};

type Props = {
	sections: ItemProviderDataSection[];
	maxItems: number;
	onReorderItems?: (result: DropResult) => void;
};

// eslint-disable-next-line jira/react/no-class-components
export default class ReorderableItemList extends Component<Props, State> {
	state = {
		isDragging: false,
	};

	onDragStart = () => {
		this.setState({
			isDragging: true,
		});
	};

	onDragEnd = (result: DropResult) => {
		this.setState({
			isDragging: false,
		});

		if (!this.props.onReorderItems) return;
		this.props.onReorderItems(result); // TODO pass the result
	};

	render() {
		const { isDragging } = this.state;
		const { sections, maxItems } = this.props;

		return (
			<>
				<Wrapper isDragging={isDragging}>
					<DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
						<ItemList sections={trimItemsBySection(maxItems, sections)} showStar />
					</DragDropContext>
				</Wrapper>
			</>
		);
	}
}

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div<{ isDragging: boolean }>(
	{
		paddingBottom: token('space.200', '16px'),
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props: any) =>
		props.isDragging &&
		`
      && {
        a:hover {
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
          background-color: ${token('elevation.surface', colors.N0)};
        }
      }
  `,
);
